import { SymmetricDirectedGraph } from './symmetric-directed-graph';;
import { Node } from '../lib/node';
import { Edge } from '../lib/edge';

export class SymmetricDirectedGraphBuilder extends SymmetricDirectedGraph {
    protected readonly selectedNodeColor = 'rgb(210,250,237)';

    protected dragNode: Node;
    protected selectedNode: Node;

    protected onDrag = false;

    /*Only for bezierpurpose*/
    protected bezierMode = false;
    private bezierOnDrag = false;


    private bezierEdge: Edge = null;

    private selectedBezierNode = 0;


    constructor(canvas: HTMLCanvasElement, rows: number, cols: number) {
        super(canvas, rows, cols);
        this.setGridVisible(false);


        /*Drag and Drop Listener*/
        this.canvas.addEventListener('mousemove', this.mouseMove, false);
        this.canvas.addEventListener('mouseup', this.mouseOut, false);
        this.canvas.addEventListener('mouseout', this.mouseOut, false);
    }

    update() {
        super.update();
    }

    getBezierMode(): boolean {
        return this.bezierMode;
    }

    resetGraph() {
        super.resetGraph();
        this.leaveBezierMode();
        this.update();
    }

    protected keyboardEvent(e: KeyboardEvent) {
        if (e.code === 'Enter') {
            this.leaveBezierMode();
        }

    }

    protected leftClick(row: number, col: number, node: Node, e: MouseEvent) {
        if (!this.bezierMode) {
            this.defaultLeftClick(row, col, node, e);
        } else {
            this.bezierLeftClick(e);
        }

        this.update();
    }

    protected rightClick(row: number, col: number, node: Node, e: MouseEvent) { }

    protected doubleClick(row: number, col: number, node: Node, e: MouseEvent) {
        if (this.bezierMode || this.onDrag){
            return;
        }

        if (node == null) {
            this.addNode(row, col, null, null);
        } else
            if (!e.ctrlKey && !e.shiftKey && !this.onDrag) {
                this.deleteNode(node);
            }
    }

    mouseMove = (e: MouseEvent) => {
        if (this.bezierMode) {
            this.bezierMouseMove(e);
        } else {
            this.defaultMouseMove(e);
        }
    }

    mouseOut = (e: MouseEvent) => {
        if (this.bezierMode) {
            this.bezierMouseOut(e);
        } else {
            this.defaultMouseOut(e);
        }
        this.update();
    }


    private defaultLeftClick(row: number, col: number, node: Node, e: MouseEvent) {
        if (e.ctrlKey || e.shiftKey) {
            if (node != null) {
                if (this.selectedNode != null) {
                    if (this.selectedNode.isNeighbor(node)) {
                        this.deleteEdge(this.selectedNode, node);
                    } else {

                        this.addEdge(this.selectedNode, node);

                        /*When creating a new Edge we enter the bezierMode*/
                        this.enterBezierMode(this.getEdge(this.selectedNode, node));
                    }

                    this.selectedNode.setDefaultColor();
                    this.selectedNode = null;
                } else {
                    this.selectedNode = node;
                    this.selectedNode.setColor(this.selectedNodeColor);
                }
            }

            this.dragNode = null;
        } else {
            this.dragNode = node;
            this.onDrag = true;
            if (this.selectedNode != null) {
                this.selectedNode.setDefaultColor();
                this.selectedNode = null;
            }

        }
    }
    private defaultMouseOut(e: MouseEvent) {
        if (this.onDrag) {
            this.onDrag = false;

            if (this.dragNode != null) {
                const newCoord: [number, number] = this.grid.getCellCoordinates(e.offsetX, e.offsetY);
                this.dragNode.setVisibility(true);
                if (!(newCoord[0] === -1 || newCoord[1] === -1)) {
                    this.dragNode.changeCoordinates(newCoord[0], newCoord[1]);
                }
            }

        }
        this.canvas.style.cursor = 'default';

    }
    private defaultMouseMove(e: MouseEvent) {
        if (this.onDrag) {
            if (this.dragNode != null) {
                this.update();
                this.dragNode.setVisibility(false);
                this.dragNode.drawShadow(this.ctx, e.offsetX, e.offsetY, this.grid);
                this.canvas.style.cursor = 'move';
            }
        }
    }
    private bezierLeftClick(e: MouseEvent) {
        if (this.bezierEdge.bezierPoint.inRadiusPoint1(e.offsetX, e.offsetY, this.grid)) {
            this.selectedBezierNode = 1;
            this.bezierOnDrag = true;
        }
        if (this.bezierEdge.bezierPoint.inRadiusPoint2(e.offsetX, e.offsetY, this.grid)) {
            this.selectedBezierNode = 2;
            this.bezierOnDrag = true;
        }



    }
    private bezierMouseOut(e: MouseEvent) {
        this.bezierOnDrag = false;
        this.canvas.style.cursor = 'default';
    }
    private bezierMouseMove(e: MouseEvent) {
        if (this.bezierOnDrag) {
            const coord: [number, number] = [e.offsetX, e.offsetY];
            this.canvas.style.cursor = 'move';
            if (this.selectedBezierNode === 1) {
                //  this.bezierEdge.bezierPoint.point1 = [e.offsetX, e.offsetY];
                this.bezierEdge.bezierPoint.changePoint1(e.offsetX, e.offsetY, this.grid);
                this.bezierEdge.enableBezier(true);

            }

            if (this.selectedBezierNode === 2) {
                //  this.bezierEdge.bezierPoint.point2 = [e.offsetX, e.offsetY];
                this.bezierEdge.bezierPoint.changePoint2(e.offsetX, e.offsetY, this.grid);
                this.bezierEdge.enableBezier(true);
            }
            this.update();
        }
        this.update();
    }

    private enterBezierMode(bezierEdge: Edge) {
        this.leaveBezierMode();

        if (bezierEdge !== null) {
            this.bezierEdge = bezierEdge;
            this.bezierEdge.bezierPoint.visible = true;
            this.bezierMode = true;

            this.selectedBezierNode = 0;
        }
        this.update();
    }

    private leaveBezierMode() {
        if (this.bezierEdge != null) {
            this.bezierEdge.bezierPoint.visible = false;
            this.bezierEdge = null;
        }

        this.bezierMode = false;
        this.selectedBezierNode = 0;
        this.update();
    }

}

